import axiosInstance from "@/api/axios-instance";

export type AnalyticsGranularity = "day" | "week" | "month";

export interface RegionUserAnalytics {
  granularity: AnalyticsGranularity;
  days: number;
  total: number;
  series: { date: string; count: number }[];
}

export async function getRegionUserAnalytics(
  id: string,
  days: number,
  granularity: AnalyticsGranularity,
): Promise<RegionUserAnalytics> {
  const response = await axiosInstance.get(`/region/${id}/user-analytics`, {
    params: { days, granularity },
  });
  return response.data as RegionUserAnalytics;
}
